import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import { Table, Checkbox, Grid } from "semantic-ui-react";
import { translate } from "react-i18next";
import ReadAxios from "../../../components/axiosComponent/read";
import CreatAxios from "../../../components/axiosComponent/create";
import LoadingPlaceholder from "../../../components/placeholderComponent/loadingPlaceholder";

class AddUserRole extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "create.user_role.title ",
      userPermissions: "",
    };
  }

  componentDidMount() {
    console.log("in component did mount of user role")
    console.log(this.props);
    if (this.props.location.state && this.props.location.state.title) {
      ReadAxios({ url: 'permission?module_name=transporter_allocation', readItems: { role: this.props.location.state.role } })
        .then((result) => {
          let permissions = result.data.permissions;
          this.setState({
            userPermissions: permissions,
          })
        })
        .catch((err) => {
          return err;
        });
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/userrole");
    this.props.history.go();
  };

  setPermission = (value, item, defaultChecked) => {
    console.log("set permission called")
    console.log(value, item, defaultChecked);
    let isActive = defaultChecked
    let payload = {
      permissionItem: item,
      isActive: isActive ? 1 : 0,
      overrideValues: value,
      role: this.props.location.state.role,
      roleId: this.props.location.state.roleId
    };
    CreatAxios({
      url: "permission",
      payload: { ...payload },
    })
      .then((res) => {
        let alert = {
          type: "success",
          messageHeader: "Success",
          messageBody: res.data.message,
        };
      })
      .catch((err) => {
        let alert = {
          type: "error",
          messageHeader: "Error",
          messageBody: err.data.message,
        };
        console.log(err);
      });
  }

  render() {
    const { t } = this.props;
    const { userPermissions } = this.state;
    if (userPermissions === '') {
      return (
        <LoadingPlaceholder />
      )
    } else {
      return (
        <React.Fragment>
          <AddTitleBar Title={this.props.t(this.state.title)} LinkName="/userrole" />
          <div className="container-fluid animated slideInDown pad w3-white">
            <div className="p-1">
              <Grid columns={4} className="ml-2">
                <Grid.Row>
                  <Grid.Column width={2} className="w3-small">
                    <h6>{t("title") || "User Role"}</h6>
                  </Grid.Column>
                  <Grid.Column width={4} className="w3-small">
                    {this.props.location.state.role}
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </div>
          </div>

          <div className="row">
            <div className="col-6 pr-0">
              <div className="animated slideInDown w3-white p-2">
                {/* <div className="m-3 pl-3"> */}
                <div className="container-fluid animated slideInDown pad w3-white" style={{ borderRadius: '50px' }}>
                  <h6>{t("permissions") || "Permissions"}</h6>
                </div>
                <Table stackable className="w3-small" size="small" selectable size="large">
                  <Table.Header className="w3-small">
                    <Table.Row>
                      <Table.HeaderCell className="p-bold-600">
                        {t("permissions") || "Masters"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("create") || "Create"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("update") || "Update"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("view") || "View"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("delete") || "Delete"}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {/* {this.props.shipment.create.orders.map((order, index) => ( */}
                    <Table.Row>
                      <Table.Cell>{t("vendor") || "Vendor"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox
                          defaultChecked={userPermissions.TA_VENDOR_MASTER.CREATE}
                          onChange={(e) => this.setPermission("CREATE", "TA_VENDOR_MASTER", e.target.checked)}
                          id='Vendor.create'
                          type="checkbox" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox"
                          defaultChecked={userPermissions.TA_VENDOR_MASTER.UPDATE}
                          onChange={(e) => this.setPermission("UPDATE", "TA_VENDOR_MASTER", e.target.checked)}
                          id='update' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox"
                          defaultChecked={userPermissions.TA_VENDOR_MASTER.VIEW}
                          onChange={(e) => this.setPermission("VIEW", "TA_VENDOR_MASTER", e.target.checked)}
                          id='view' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox"
                          defaultChecked={userPermissions.TA_VENDOR_MASTER.DELETE}
                          onChange={(e) => this.setPermission("DELETE", "TA_VENDOR_MASTER", e.target.checked)}
                          id='delete' name='Vendor' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("vendor_share") || "Vendor Share"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox"
                          defaultChecked={userPermissions.TA_VENDOR_SHARE.CREATE}
                          onChange={(e) => this.setPermission("VIEW", "TA_VENDOR_SHARE", e.target.checked)}
                          id='Vendor_Share_create' name='VendorShare' value='' className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox"

                          defaultChecked={userPermissions.TA_VENDOR_SHARE.UPDATE}
                          onChange={(e) => this.setPermission("UPDATE", "TA_VENDOR_SHARE", e.target.checked)}
                          id='Vendor_Share_update' name='VendorShare' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox"
                          defaultChecked={userPermissions.TA_VENDOR_SHARE.VIEW}
                          onChange={(e) => this.setPermission("VIEW", "TA_VENDOR_SHARE", e.target.checked)}
                          id='Vendor_Share_view' name='VendorShare' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_VENDOR_SHARE", e.target.checked)}
                          defaultChecked={userPermissions.TA_VENDOR_SHARE.DELETE}
                          id='Vendor_Share_delete' name='VendorShare' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("vendor_group") || "Vendor Group"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_VENDOR_GROUP", e.target.checked)}
                          defaultChecked={userPermissions.TA_VENDOR_GROUP.CREATE}
                          id='Vendor_Group_create' name='VendorGroup' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_VENDOR_GROUP", e.target.checked)}
                          defaultChecked={userPermissions.TA_VENDOR_GROUP.UPDATE}
                          id='Vendor_Group_update' name='VendorGroup' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_VENDOR_GROUP", e.target.checked)}
                          defaultChecked={userPermissions.TA_VENDOR_GROUP.VIEW}
                          id='Vendor_Group_view' name='VendorGroup' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_VENDOR_GROUP", e.target.checked)}
                          defaultChecked={userPermissions.TA_VENDOR_GROUP.DELETE}
                          id='Vendor_Group_delete' name='VendorGroup' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("vehicle_type") || "Vehicle Type"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_VEHICLE_TYPE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_VEHICLE_TYPE_MASTER.CREATE}
                          id='Vendor_Type_create' name='VendorType' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_VEHICLE_TYPE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_VEHICLE_TYPE_MASTER.UPDATE}
                          id='Vendor_Type_update' name='VendorType' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_VEHICLE_TYPE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_VEHICLE_TYPE_MASTER.VIEW}
                          id='Vendor_Type_view' name='VendorType' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_VEHICLE_TYPE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_VEHICLE_TYPE_MASTER.DELETE}
                          id='Vendor_Type_delete' name='VendorType' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("user") || "User"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_USER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_MASTER.CREATE}
                          id='User_create' name='User' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_USER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_MASTER.UPDATE}
                          id='User_update' name='User' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_USER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_MASTER.VIEW}
                          id='User_view' name='User' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_USER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_MASTER.DELETE}
                          id='User_delete' name='User' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("driver") || "Driver"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_DRIVER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_DRIVER_MASTER.CREATE}
                          id='Driver_create' name='Driver' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_DRIVER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_DRIVER_MASTER.UPDATE}
                          id='Driver_update' name='Driver' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_DRIVER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_DRIVER_MASTER.VIEW}
                          id='Driver_view' name='Driver' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_DRIVER_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_DRIVER_MASTER.DELETE}
                          id='Driver_delete' name='Driver' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("consignor") || "Consignor"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_CONSIGNOR_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNOR_MASTER.CREATE}
                          id='Consignor_create' name='Consignor' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_CONSIGNOR_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNOR_MASTER.UPDATE}
                          id='Consignor_update' name='Consignor' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_CONSIGNOR_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNOR_MASTER.VIEW}
                          id='Consignor_view' name='Consignor' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_CONSIGNOR_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNOR_MASTER.DELETE}
                          id='Consignor_delete' name='Consignor' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("consignee") || "Consignee"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_CONSIGNEE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNEE_MASTER.CREATE}
                          id='Consignee_create' name='Consignee' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_CONSIGNEE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNEE_MASTER.UPDATE}
                          id='Consignee_update' name='Consignee' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_CONSIGNEE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNEE_MASTER.VIEW}
                          id='Consignee_view' name='Consignee' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_CONSIGNEE_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CONSIGNEE_MASTER.DELETE}
                          id='Consignee_delete' name='Consignee' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("city") || "City"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_CITY_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CITY_MASTER.CREATE}
                          id='City_create' name='City' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_CITY_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CITY_MASTER.UPDATE}
                          id='City_update' name='City' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_CITY_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CITY_MASTER.VIEW}
                          id='City_view' name='City' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_CITY_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CITY_MASTER.DELETE}
                          id='City_delete' name='City' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("route") || "Route"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_CHECKPOINT_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CHECKPOINT_MASTER.CREATE}
                          id='Route_create' name='Route' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_CHECKPOINT_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CHECKPOINT_MASTER.UPDATE}
                          id='Route_update' name='Route' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_CHECKPOINT_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CHECKPOINT_MASTER.VIEW}
                          id='Route_view' name='Route' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_CHECKPOINT_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_CHECKPOINT_MASTER.DELETE}
                          id='Route_delete' name='Route' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("product") || "Product"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_SKU_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_SKU_MASTER.CREATE}
                          id='Product_create' name='Product' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_SKU_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_SKU_MASTER.UPDATE}
                          id='Product_update' name='Product' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_SKU_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_SKU_MASTER.VIEW}
                          id='Product_view' name='Product' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_SKU_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_SKU_MASTER.DELETE}
                          id='Product_delete' name='Product' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("user_role") || "UserRole"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("CREATE", "TA_USER_ROLE", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_ROLE.CREATE}
                          id='UserRole_create' name='UserRole' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("UPDATE", "TA_USER_ROLE", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_ROLE.UPDATE}
                          id='UserRole_update' name='UserRole' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_USER_ROLE", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_ROLE.VIEW}
                          id='UserRole_view' name='UserRole' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("DELETE", "TA_USER_ROLE", e.target.checked)}
                          defaultChecked={userPermissions.TA_USER_ROLE.DELETE}
                          id='UserRole_delete' name='UserRole' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>

                    <Table.Row>
                      <Table.Cell>{t("master") || "Master"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        N/A
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        N/A
                        </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" onChange={(e) => this.setPermission("VIEW", "TA_OVERALL_MASTER", e.target.checked)}
                          defaultChecked={userPermissions.TA_OVERALL_MASTER.VIEW}
                          id='TA_OVERALL_MASTER.VIEW' name='TA_OVERALL_MASTER.VIEW' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        N/A
                      </Table.Cell>
                    </Table.Row>

                  </Table.Body>
                </Table>
                {/* </div> */}
              </div>
            </div>
            <div className="col-6">
              {/* <div class="row"> */}
              <div className="animated slideInDown w3-white p-2">
                {/* <div className="m-3 pl-3"> */}
                <div className="container-fluid animated slideInDown pad w3-white">
                  <h6>{t("transactions") || "Transactions"}</h6>
                </div>
                <Table stackable className="w3-small" size="small" selectable size="large">
                  <Table.Header className="w3-small">
                    <Table.Row>
                      <Table.HeaderCell className="p-bold-600">
                        {t("details") || "Details"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("create") || "Create"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("update") || "Update"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("view") || "View"}
                      </Table.HeaderCell>
                      <Table.HeaderCell className="p-bold-600">
                        {t("delete") || "Delete"}
                      </Table.HeaderCell>
                    </Table.Row>
                  </Table.Header>
                  <Table.Body>
                    {/* {this.props.shipment.create.orders.map((order, index) => ( */}
                    <Table.Row>
                      <Table.Cell>{t("shipment") || "Shipment"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_SHIPMENT.CREATE} onChange={(e) => this.setPermission("CREATE", "TA_SHIPMENT", e.target.checked)}
                          id='ts-create' name='Shipment' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_SHIPMENT.UPDATE} onChange={(e) => this.setPermission("UPDATE", "TA_SHIPMENT", e.target.checked)}
                          id='ts-update' name='Shipment' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_SHIPMENT.VIEW} onChange={(e) => this.setPermission("VIEW", "TA_SHIPMENT", e.target.checked)}
                          id='ts-view' name='Shipment' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_SHIPMENT.DELETE} onChange={(e) => this.setPermission("DELETE", "TA_SHIPMENT", e.target.checked)}
                          id='ts-delete' name='Shipment' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("document") || "Documents"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DOCUMENTS.CREATE} onChange={(e) => this.setPermission("CREATE", "TA_DOCUMENTS", e.target.checked)}
                          id='td-create' name='Documents' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DOCUMENTS.UPDATE} onChange={(e) => this.setPermission("UPDATE", "TA_DOCUMENTS", e.target.checked)}
                          id='td-update' name='Documents' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DOCUMENTS.VIEW} onChange={(e) => this.setPermission("VIEW", "TA_DOCUMENTS", e.target.checked)}
                          id='td-view' name='Documents' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DOCUMENTS.DELETE} onChange={(e) => this.setPermission("DELETE", "TA_DOCUMENTS", e.target.checked)}
                          id='td-delete' name='Documents' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("reports") || "Reports"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_REPORTS.CREATE} onChange={(e) => this.setPermission("CREATE", "TA_REPORTS", e.target.checked)}
                          id='tr-create' name='Reports' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_REPORTS.UPDATE} onChange={(e) => this.setPermission("UPDATE", "TA_REPORTS", e.target.checked)}
                          id='tr-update' name='Reports' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_REPORTS.VIEW} onChange={(e) => this.setPermission("VIEW", "TA_REPORTS", e.target.checked)}
                          id='tr-view' name='Reports' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_REPORTS.DELETE} onChange={(e) => this.setPermission("DELETE", "TA_REPORTS", e.target.checked)}
                          id='tr-delete' name='Reports' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("dashboard") || "Dashboard"}</Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DASHBOARD.CREATE} onChange={(e) => this.setPermission("CREATE", "TA_DASHBOARD", e.target.checked)}
                          id='tda-create' name='Dashboard' value="create" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DASHBOARD.UPDATE} onChange={(e) => this.setPermission("UPDATE", "TA_DASHBOARD", e.target.checked)}
                          id='tda-update' name='Dashboard' value="update" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DASHBOARD.VIEW} onChange={(e) => this.setPermission("VIEW", "TA_DASHBOARD", e.target.checked)}
                          id='tda-view' name='Dashboard' value="view" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell style={{ textAlign: "center" }}>
                        <Checkbox type="checkbox" defaultChecked={userPermissions.TA_DASHBOARD.DELETE} onChange={(e) => this.setPermission("DELETE", "TA_DASHBOARD", e.target.checked)}
                          id='tda-delete' name='Dashboard' value="delete" className="form-check-input large" />
                      </Table.Cell>
                    </Table.Row>
                  </Table.Body>
                </Table>
              </div>
              <div className="animated slideInDown w3-white p-2">
                <div className="container-fluid animated slideInDown pad w3-white">
                  <h6>{t("product_access") || "Product Access"}</h6>
                </div>
                <Table stackable className="w3-small" size="small" selectable size="large">
                  <Table.Body>
                    {/* {this.props.shipment.create.orders.map((order, index) => ( */}
                    <Table.Row>
                      <Table.Cell>{t("elixia_speed") || "Elixia Speed"}</Table.Cell>
                      <Table.Cell>
                        <Checkbox type="checkbox" className="form-check-input large" value="" />
                      </Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("elixia_monitor") || "Elixia Monitor"}</Table.Cell>
                      <Table.Cell>
                        <Checkbox type="checkbox" className="form-check-input large" value="" />
                      </Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("transport_allocation") || "Transport Allocation"}</Table.Cell>
                      <Table.Cell>
                        <Checkbox type="checkbox" className="form-check-input large" value="" />
                      </Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("dispatch_tracker") || "Dispatch Tracker"}</Table.Cell>
                      <Table.Cell>
                        <Checkbox type="checkbox" name="dispatched_tracker" className="form-check-input large" />
                      </Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                    </Table.Row>
                    <Table.Row>
                      <Table.Cell>{t("billing_platform") || "Billing Platform"}</Table.Cell>
                      <Table.Cell>
                        <Checkbox type="checkbox" className="form-check-input large" value="" />
                      </Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                      <Table.Cell></Table.Cell>
                    </Table.Row>
                    {/* ))} */}
                  </Table.Body>
                </Table>
                {/* </div> */}
              </div>
              {/* </div> */}
            </div>
          </div>
        </React.Fragment>
      )
    }
  }
}
export default translate("user_role")(AddUserRole);